<template>
  <div v-if="post">
    <v-article
      :post="post"
      return-label="Return to Useful resources"
      :return-to="{ name: 'useful-resources', params: { homeSlug } }"
    >
      <span class="category">{{ post.category.name }}</span>
    </v-article>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VArticle from "@/components/Article.vue";

export default {
  metaInfo() {
    return {
      title: this.post.title + " | Useful Resources",
    };
  },
  props: {
    homeSlug: String,
    slug: String,
  },
  components: {
    VArticle,
  },
  mounted() {
    this.fetchUsefulResourcesItem({ home: this.homeSlug, slug: this.slug });
  },
  methods: {
    ...mapActions(["fetchUsefulResourcesItem"]),
  },
  computed: {
    post() {
      return this.$store.getters.getUsefulResourcesItem(this.slug);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.category {
  display: block;
  font: 600 16px/1 CenturyGothic;
  text-transform: uppercase;
  margin-bottom: 0.5em;
  color: #00205b;
}
</style>
